// Translation dictionary for the OYU Fest "Battle of Clans" app.
//
// ru = the existing wording (preserved verbatim from the original UI).
// kk = natural, correct Kazakh (the festival audience is in Kazakhstan).
// en = natural English.
//
// Brand terms stay as-is across all languages: "Hero's Journey", "Hero's Week",
// "InBody", "OYU Fest", "Instagram", "App Store", "Google Play".
//
// Placeholders use {name} syntax and are filled by t(key, vars).

export type Lang = "kk" | "ru" | "en";

export const LANGS: Lang[] = ["kk", "ru", "en"];

export type Dict = Record<string, string>;

const ru: Dict = {
  // ---- Language picker (Lang.tsx) ----
  "lang.title": "Выбери язык",
  "lang.subtitle": "Choose your language · Тілді таңда",
  "lang.kk": "Қазақша",
  "lang.ru": "Русский",
  "lang.en": "English",

  // ---- Entry.tsx ----
  "entry.tagline":
    "Регистрируйся на фестивале, проходи зоны и забери приз — неделю тренировок Hero's Week.",
  "entry.register": "Регистрация",
  "entry.login": "Войти",
  "entry.title": "Hero's Journey на OYU Fest",
  "entry.subtitle": "Проходи зоны — забирай призы",
  "entry.dates": "с 4 июля 13:00 по 5 июля 21:00",
  "register.fromLogin": "Аккаунт с этим номером не найден. Заполни данные — и участвуй!",
  "entry.zone1.note": "Главный приз — полугодовой абонемент от Hero's Journey",
  "entry.zone2.note": "Узнай процент жира и мышц",
  "entry.zone3.note": "Выполни все задания — получи 3 пробные тренировки стоимостью 9 990 тг",
  "entry.zone1.desc":
    "30 секунд на гребном тренажёре. Топ-3 среди женщин и мужчин — абонементы до полугода и мерч Red Bull.",
  "entry.zone2.desc": "Бесплатный InBody-замер состава тела.",
  "entry.zone3.desc": "Собери клан и выполните задания вместе.",
  "entry.hw":
    "Призовой фонд — более 1 000 000 ₸ в эквиваленте! Участвуй в активностях от Hero's Journey и получай гарантированные призы за выполнение заданий.",
  "entry.prizesLink": "Подробнее о призах",
  "entry.cta": "Участвовать",
  "entry.haveAccount": "У меня уже есть аккаунт",

  // ---- Prizes.tsx ----
  "tab.prizes": "Призы",
  "prizes.title": "Призы фестиваля",
  "prizes.subtitle": "Что и как можно выиграть на OYU Fest",
  "prizes.schedule.title": "Когда проходят соревнования",
  "prizes.schedule.body":
    "Участие — с 13:00 4 июля до 21:00 5 июля. Результаты победителей будут видны в приложении, а итоги объявим в сторис @herosjourneykz после завершения соревнований.",
  "prizes.rules.title": "Правила призов",
  "prizes.rules.body":
    "Выигранные призы и абонементы — именные: передача третьим лицам и перепродажа не допускаются.",
  "prizes.back": "Назад",
  "prizes.rowing.title": "Зона 1 — «Узнай свою мощность»",
  "prizes.rowing.how":
    "30 секунд работы на гребном тренажёре — дистанция превращается в ватты. Отдельный зачёт среди женщин и мужчин.",
  "prizes.rowing.women": "Женщины",
  "prizes.rowing.men": "Мужчины",
  "prizes.place1": "Полугодовой абонемент + мерч Red Bull",
  "prizes.place2": "Два месячных абонемента (себе и другу) + сумка Hero's Journey",
  "prizes.place3": "Месячный абонемент",
  "prizes.hw.title": "Hero's Week — за участие",
  "prizes.hw.body":
    "Прими участие в гребле или выполни клановые задания — и получи 3 бесплатные тренировки в Hero's Journey.",
  "prizes.hwGift.title": "Подарочный Hero's Week",
  "prizes.hwGift.body":
    "Ты уже с нами! За участие в фестивале дарим подарочный Hero's Week — сертификат на неделю тренировок. Активировать можно в течение 3 месяцев.",
  "prizes.inbody.title": "Зона 2 — «Оцифруй своё тело»",
  "prizes.inbody.body":
    "Результат InBody-замера появится здесь, в веб-сервисе. Детальная разбивка процента жира и мышц — в приложении Hero's Journey.",
  "prizes.clan.title": "Зона 3 — «Битва кланов»",
  "prizes.clan.body": "Выполните задания всей командой — каждый получит Hero's Week. Список заданий — на вкладке «Кланы».",

  // ---- Stations.tsx: призовые строки ----
  "stations.rowing.prize": "🏆 Топ-3 — абонементы и мерч, всем участникам — Hero's Week",
  "stations.inbody.prize": "📱 Детальный разбор — в приложении Hero's Journey",
  "stations.battle.prize": "🎁 Выполни задания — получи Hero's Week",

  // ---- Rowing.tsx (Зона 1: мой результат + лидерборд) ----
  "rowing.myResult": "Мой результат",
  "rowing.lbTitle": "Лидерборд",
  "rowing.noRows": "Пока нет результатов — стань первым!",
  "rowing.motivation": "1 место — полугодовой абонемент + мерч Red Bull. Греби мощнее!",

  // ---- Register.tsx ----
  "register.title": "Регистрация",
  "register.subtitle":
    "Оставь номер и имя — этого хватит, чтобы участвовать в активностях Hero's Journey и забрать приз.",
  "register.phoneLabel": "Телефон",
  "register.nickLabel": "Ник (латиницей, без пробелов)",
  "register.nickPlaceholder": "Например: hero_77",
  "register.submit": "Зарегистрироваться",
  "register.submitting": "Регистрируем…",
  "register.haveAccount": "У меня уже есть регистрация",
  "register.dobLabel": "День рождения",
  "register.dobPlaceholder": "ДД.ММ.ГГГГ",
  "register.dob.day": "ДД",
  "register.dob.month": "ММ",
  "register.dob.year": "ГГГГ",
  "register.dob.note": "Участие в соревнованиях — с 16 лет.",
  "register.dob.confirm": "Подтвердить",
  "register.errNoDob": "Укажи свой день рождения",
  "register.errBadDate": "Проверь дату рождения",
  "register.errUnderage": "Участвовать в соревнованиях можно с 16 лет",
  "register.sexLabel": "Пол",
  "register.sexF": "Женский",
  "register.sexM": "Мужской",
  "register.errNoSex": "Выбери пол",
  "register.errInvalidPhone": "Проверь свой номер телефона",
  "register.errNoNick": "Введи свой ник",
  "register.errNickLatin": "Ник — только латинские буквы, цифры и _, без пробелов (2–20 символов)",
  "register.existing.title": "Ты уже наш клиент",
  "register.existing.body":
    "Приз фестиваля — только для новых гостей Hero's Journey. Этот номер уже есть в нашей базе, так что приз за него не положен. Но ты всё равно можешь прийти на фестиваль и поддержать друзей!",
  "register.existing.otherNumber": "Ввести другой номер",
  "register.existing.home": "На главную",

  // ---- Login.tsx ----
  "login.title": "Вход",
  "login.subtitle": "Введи номер телефона, по которому ты регистрировался.",
  "login.phoneLabel": "Телефон",
  "login.submit": "Войти",
  "login.submitting": "Проверяем…",
  "login.errInvalidPhone": "Неверный номер",
  "otp.title": "Введите код",
  "otp.subtitle": "Мы отправили SMS с кодом подтверждения.",
  "otp.codeLabel": "Код из SMS",
  "otp.codePlaceholder": "0000",
  "otp.getCode": "Получить код",
  "otp.sending": "Отправляем…",
  "otp.verify": "Войти",
  "otp.verifying": "Проверяем…",
  "otp.resend": "Отправить код ещё раз",
  "otp.errBadCode": "Неверный код",
  "login.notFound.title": "Мы тебя не нашли",
  "login.notFound.body":
    "По этому номеру пока нет регистрации. Зарегистрируйся — это займёт минуту.",
  "login.notFound.register": "Зарегистрироваться",
  "login.notFound.otherNumber": "Ввести другой номер",

  // ---- Hub.tsx ----
  "hub.greeting": "Привет, {name}!",
  "hub.greetingFallback": "герой",
  "hub.subtitle": "Твой штаб на фестивале Hero's Journey",
  "hub.live": "live",
  "hub.loading": "Загружаем…",
  "hub.backToLogin": "На вход",
  "hub.progress.title": "Прогресс фестиваля",
  "hub.progress.count": "{done} / 3 зоны",
  "hub.rowing.zone": "Зона 1",
  "hub.zoneLocked.rowing": "Соревнование по гребле — для новых гостей Hero's Journey.",
  "hub.zoneLocked.inbody": "Бесплатный InBody-замер — для новых гостей Hero's Journey.",
  "hub.zoneLocked.friend":
    "💪 Приведи друга, который ещё не был в HJ, — он может выиграть полугодовой абонемент!",
  "hub.rowing.metric": "Дистанция · мощность {power} Вт",
  "hub.clan.notReady":
    "Чтобы клан считался готовым, нужно минимум 3 участника. Сейчас: {count}. Зови друзей по коду {code}.",
  "hub.clan.title": "Битва кланов",
  "hub.clan.body":
    "По желанию: собери клан или вступи по коду и проходите задания вместе. Приз можно забрать и в одиночку — через станцию гребли.",
  "hub.clan.bodyGift":
    "Собери клан или вступи по коду и выполните задания вместе — получишь подарочный Hero's Week для друга.",
  "hub.clan.create": "Создать клан",
  "hub.clan.join": "Вступить по коду",
  "hub.rowing.title": "Узнай свою мощность",
  "hub.rowing.distance": "Дистанция",
  "hub.rowing.power": "Мощность",
  "hub.rowing.empty":
    "Подойди к станции гребли на фестивале — твой результат появится здесь.",
  "hub.inbody.title": "Оцифруй своё тело",
  "hub.inbody.pbf": "% жира",
  "hub.inbody.cta": "Полный разбор — в приложении →",
  "hub.inbody.empty":
    "Пройди InBody на станции (Зона 2) — увидишь свой результат здесь.",
  "hub.prize.label": "Приз — Hero's Week",
  "hub.prize.value": "3 тренировки бесплатно",
  "hub.prize.granted": "Hero's Week активирован 🎉",
  "hub.prize.claim": "Забрать Hero's Week",
  "hub.prize.locked":
    "Чтобы забрать приз — выполни задания клана или пройди станцию гребли.",
  "hub.noPhone": "Нет номера телефона",

  // ---- Tab bar (TabBar.tsx) ----
  "tab.home": "Главная",
  "tab.stations": "Зоны",
  "tab.clans": "Кланы",
  "tab.profile": "Профиль",

  // ---- Stations.tsx ----
  "stations.title": "Зоны фестиваля",
  "stations.subtitle": "Зоны Hero's Journey на фестивале",
  "stations.zonePrefix": "Зона {n}",
  "stations.rowing.title": "Узнай свою мощность",
  "stations.rowing.desc": "Подойди к станции гребли — результат появится в штабе.",
  "stations.rowing.doneDesc": "Результат записан: {distance} м · {power} Вт.",
  "stations.inbody.title": "Оцифруй своё тело",
  "stations.inbody.desc": "Пройди замер состава тела на станции (Зона 2).",
  "stations.inbody.doneDesc": "Замер готов — открой «Мой состав тела» в штабе.",
  "stations.battle.title": "Битва кланов",
  "stations.battle.desc": "Собери клан или вступи по коду и проходите задания вместе.",
  "stations.battle.doneDesc": "Ты в клане «{name}» — задания: {done}/{total}.",
  "stations.status.done": "Пройдено",
  "stations.status.pending": "Ждёт тебя",

  // ---- Profile.tsx ----
  "profile.title": "Профиль",
  "profile.phoneLabel": "Телефон",
  "profile.nickLabel": "Ник",
  "profile.nickSave": "Сохранить",
  "profile.nickSaving": "Сохраняем…",
  "profile.nickSaved": "Ник обновлён ✓",
  "profile.langLabel": "Язык",
  "profile.statusTitle": "Мой статус",
  "profile.status.clanIn": "В клане «{name}»",
  "profile.status.clanNone": "Пока без клана",
  "profile.status.prizeGranted": "Приз Hero's Week активирован",
  "profile.status.prizeEligible": "Приз готов — забери в штабе",
  "profile.status.prizeLocked": "Приз ещё не открыт",
  "profile.toHub": "В штаб",
  "profile.logout": "Выйти",

  // units
  "unit.meters": "м",
  "unit.watts": "Вт",
  "unit.percent": "%",

  // ---- Clan.tsx ----
  "clan.noPhone": "Нет номера телефона",
  "clan.back": "Назад",
  "clan.createTitle": "Создать клан",
  "clan.joinTitle": "Вступить по коду",
  "clan.nameLabel": "Название клана",
  "clan.namePlaceholder": "Например: Tigers",
  "clan.mottoLabel": "Девиз (необязательно)",
  "clan.mottoPlaceholder": "Один за всех",
  "clan.emojiLabel": "Эмодзи (необязательно)",
  "clan.codeLabel": "Код клана",
  "clan.codePlaceholder": "Например, TIGR12",
  "clan.codeHint": "Код тебе даст лидер клана.",
  "clan.create": "Создать клан",
  "clan.creating": "Создаём…",
  "clan.join": "Вступить",
  "clan.joining": "Вступаем…",
  "clan.errNoName": "Введи название клана",
  "clan.errNameLatin": "Название клана — только латинские буквы, цифры и пробелы (2–24 символа)",
  "clan.errNoCode": "Введи код клана",
  "clan.errAlreadyIn": "Ты уже состоишь в клане",
  "clan.errCreateFailed": "Не удалось создать клан",
  "clan.errJoinFailed": "Не удалось вступить в клан",
    "task.header": "Задание",
  "task.logo_story.title": "Групповое фото «HJ»",
  "task.logo_story.desc":
    "Сделайте групповое фото, изобразив буквы «HJ» своими телами. Каждый участник клана выкладывает фото в сторис и отмечает @herosjourneykz и @oyu.fest.",
  "task.story.instaLabel": "Твой Instagram",
  "task.story.instaPh": "@username",
  "task.story.checkbox": "Я выложил(а) сторис и отметил(а) оба аккаунта",
  "task.story.submit": "Отправить на проверку",
  "task.story.submitting": "Отправляем…",
  "task.story.pending": "⏳ Задание на проверке",
  "task.story.pendingHint": "Модератор проверит сторис и засчитает выполнение.",
  "task.story.approved": "Выполнено 🎉",
  "task.story.progress": "Выполнили: {done} из {total}",
  "task.story.needClan": "Задание клановое — сначала создай клан или вступи по коду.",
  "task.story.errNoInsta": "Укажи свой Instagram",
  "task.story.st.pending": "на проверке",
  "task.story.st.none": "ещё не выложил(а)",
  "task.story.st.approved": "выполнено",
  "task.group_plank.title": "Групповая планка",
  "task.group_plank.desc":
    "Найдите тренера Hero's Journey на площадке. По его команде встаньте в планку «стульчик» всей командой, держась руками и спинами друг к другу, и продержитесь 2 минуты. Тренер следит за временем и после выполнения засчитает задание.",
  "task.redbull_activity.title": "Активность в Red Bull",
  "task.redbull_activity.desc":
    "Пройдите любое активити в зоне нашего партнёра Red Bull всем кланом. Сотрудник зоны отметит выполнение. Делишься моментом в сторис — отметь @redbullkazakhstan!",
  "clan.tasksTitle": "Задания кланов",
  "clan.tasksIntro": "Выполните всей командой — каждый получит Hero's Week:",
  "clan.list.title": "Кланы фестиваля",
  "clan.list.empty": "Пока нет ни одного клана — создай первый!",
  "clan.list.yours": "Твой клан",
  "clan.list.members": "Участников: {count}",
  "clan.list.tasks": "Задания: {done}/{total}",
  "clan.list.completed": "Все задания",

  // ---- Coach.tsx ----
  "coach.title": "Панель тренера",
  "coach.title.coach": "Панель тренера",
  "coach.title.marketing": "Панель маркетинга",
  "coach.title.redbull": "Панель Red Bull",
  "coach.title.admin": "Панель стаффа",
  "coach.tab.clans": "Кланы",
  "coach.myTaskProgress": "Твоё задание отмечено у {done} из {total} кланов",
  "coach.rowing.recent": "Последние внесённые",
  "coach.board.hint": "Топ-5 каждого зачёта. Итоги — после завершения соревнований 5 июля.",
  "coach.rowing.nickLabel": "Ник участника",
  "coach.rowing.nickPlaceholder": "hero_77",
  "coach.rowing.orPhoneLabel": "…или телефон",
  "coach.rowing.errWho": "Укажи ник или телефон участника",
  "coach.rowing.errNickUnsupported":
    "Сервер пока не принимает запись по нику — введи номер телефона участника",
  "coach.rowing.editHint": "Повторная запись тому же участнику перезаписывает результат — так можно исправить ошибку. Тапни строку в «Последних внесённых», чтобы подставить участника.",
  "error.participant_not_found": "Участник не найден — проверь ник или номер телефона",
  "coach.tab.rowing": "Гребля",
  "coach.prizeGranted": "приз выдан",
  "coach.ready": "готов",
  "coach.leader": "Лидер: {name}",
  "coach.members": "Участников: {count} · Заданий: {done}/{total}",
  "coach.noTasks": "Заданий нет",
  "coach.searchPlaceholder": "Поиск по названию клана или лидеру",
  "coach.nothingFound": "Ничего не найдено",
  "coach.noClans": "Кланов пока нет",
  "coach.errLoadClans": "Не удалось загрузить кланы",
  "coach.errCheck": "Не удалось отметить задание",
  "coach.rowing.recordTitle": "Записать результат",
  "coach.rowing.guestPhone": "Телефон гостя",
  "coach.rowing.distanceLabel": "Дистанция, м",
  "coach.rowing.distancePlaceholder": "например, 500",
  "coach.rowing.save": "Записать результат",
  "coach.rowing.saving": "Сохраняем…",
  "coach.rowing.distance": "Дистанция",
  "coach.rowing.power": "Мощность",
  "coach.rowing.leaderboard": "Лидерборд",
  "coach.rowing.guestFallback": "Гость",
  "coach.rowing.boardEmpty": "Результатов пока нет",
  "coach.rowing.errPhone": "Проверь номер телефона",
  "coach.rowing.errDistance": "Введи дистанцию в метрах",
  "coach.rowing.errSave": "Не удалось записать результат",
  "coach.rowing.errBoard": "Не удалось загрузить лидерборд",
  "lb.title": "Лидерборд · Узнай свою мощность",
  "lb.live": "в эфире",
  "lb.updated": "Обновлено",
  "lb.participants": "Участники: {n}",
  "lb.total": "Все вместе проплыли {km} км",
  "lb.offline": "нет связи",
  "lb.women": "Женщины",
  "lb.men": "Мужчины",
  "lb.spotlight.recorded": "Результат записан!",
  "lb.spotlight.placeWomen": "{rank}-е место среди женщин",
  "lb.spotlight.placeMen": "{rank}-е место среди мужчин",
  "lb.spotlight.overall": "{rank}-е место в общем зачёте",
  "staff.title": "Служебный экран",
  "staff.subtitle": "Введи код доступа. Его выдаёт организатор.",
  "staff.placeholder": "Код доступа",
  "staff.submit": "Войти",
  "staff.checking": "Проверяем…",
  "staff.error": "Неверный код",
  "staff.youAre": "Вы: {role}",
  "admin.title": "Админка",
  "admin.tab.stats": "Статистика",
  "admin.tab.tasks": "Задания",
  "admin.tab.winners": "Победители",
  "admin.tab.stories": "Сторис",
  "admin.story.title": "Проверка сторис",
  "admin.story.empty": "Заявок пока нет",
  "admin.story.pendingCount": "ожидают: {n}",
  "admin.story.approve": "Засчитать",
  "admin.story.reject": "Отклонить",
  "admin.story.pending": "на проверке",
  "admin.story.approved": "засчитано",
  "admin.winners.women": "Топ-3 — женщины",
  "admin.winners.men": "Топ-3 — мужчины",
  "admin.winners.empty": "Пока нет результатов",
  "admin.winners.hint": "Финальный топ гребли. Свяжитесь с победителями для выдачи награды.",
  "admin.forbidden": "Доступ только для организатора.",
  "admin.refresh": "Обновить",
  "admin.stat.participants": "Регистрации",
  "admin.stat.menWomen": "М {men} · Ж {women} · не указан {other}",
  "admin.stat.clans": "Кланы",
  "admin.stat.clansSub": "готовы {ready} · завершили {completed}",
  "admin.stat.members": "Участников в кланах",
  "admin.stat.rowing": "Гребля",
  "admin.stat.rowingSub": "результатов · с призом {prize}",
  "admin.stat.top": "Лидер: {name} · {power} Вт",
  "admin.stat.prizes": "Выдано Hero's Week",
  "admin.stat.tasksTitle": "Выполнение заданий",
  "admin.stat.clansDone": "{n} кланов",
  "admin.empty": "—",
  "admin.tab.rowing": "Гребля",
  "admin.rowing.hint": "Все результаты гребли: {n}",
  "admin.rowing.empty": "Пока нет ни одного результата.",
  "admin.rowing.page": "Стр. {p} из {n}",
  "admin.rowing.noPhones": "Телефоны появятся, когда бэкенд начнёт отдавать /admin/rowing.",
  "admin.rowing.f": "Ж",
  "admin.rowing.m": "М",
  "admin.inbody.title": "Прошли InBody",
  "admin.inbody.empty": "Пока никто не прошёл замер.",
  "admin.inbody.unavailable": "Список появится, когда бэкенд начнёт отдавать /admin/inbody.",
  "admin.task.listTitle": "Все задания",
  "admin.task.newTitle": "Новое задание",
  "admin.task.titleLabel": "Название задания",
  "admin.task.titlePh": "Что должен сделать клан",
  "admin.task.roleLabel": "Подтверждает",
  "admin.task.active": "Активно",
  "admin.task.sort": "Порядок",
  "admin.task.create": "Создать задание",
  "admin.task.save": "Сохранить",
  "admin.task.saving": "Сохраняем…",
  "admin.task.off": "выключено",
  "admin.task.errSave": "Не удалось сохранить",
  "admin.task.errLoad": "Не удалось загрузить",
  "staff.role.admin": "Организатор",
  "staff.role.marketing": "Маркетинг",
  "staff.role.coach": "Тренер",
  "staff.role.redbull": "RedBull",

  // ---- InBody.tsx ----
  "inbody.back": "Назад",
  "inbody.title": "Оцифруй своё тело",
  "inbody.loading": "Загружаем…",
  "inbody.empty": "Пройди InBody на станции (Зона 2) — результат появится здесь.",
  "inbody.appPrompt": "Скачай приложение Hero's Journey и войди по своему номеру — полные результаты замера (вес, мышцы, жир, метаболизм) появятся там.",
  "inbody.score": "Балл InBody",
  "inbody.measuredAt": "Замер: {date}",
  "inbody.about.title": "Что такое InBody",
  "inbody.about.body":
    "InBody — это анализатор состава тела. Ты встаёшь на платформу, берёшься за рукоятки — и через 60 секунд прибор показывает, из чего ты состоишь. Не общий вес, а раскладку: сколько в тебе мышц, сколько жира, где именно этот жир находится и сколько воды в тканях. Прибор пропускает через тело слабый безопасный ток — мышцы, жир и вода проводят его по-разному, и на этой разнице строится вся картина. Метод называется биоимпеданс, им пользуются клиники и спортивные команды по всему миру.",
  "inbody.metabolicAge": "Метаболический возраст",
  "inbody.pbf": "% жира",
  "inbody.ctaQuestion":
    "Хочешь увидеть полный разбор — вес, мышцы, висцеральный жир и метаболизм?",
  "inbody.ctaHint": "Открой полный отчёт в приложении Hero's Journey",
  "inbody.download": "Скачать приложение",

  // ---- Done.tsx ----
  "done.title": "Все задания выполнены!",
  "done.subtitle": "Ваш клан забрал приз — 3 тренировки по программе Hero's Week.",
  "done.appHintWithPhone":
    "Скачайте приложение Hero's Journey и войдите по номеру {phone} — подарок уже внутри.",
  "done.appHintNoPhone":
    "Скачайте приложение Hero's Journey и войдите по номеру телефона — подарок уже внутри.",
  "done.appStore": "Скачать в App Store",
  "done.googlePlay": "Скачать в Google Play",
  "done.linksSoon": "Ссылки на приложение появятся скоро.",

  // ---- PrizeModal.tsx ----
  "prize.today": "Сегодня",
  "prize.tomorrow": "Завтра",
  "prize.dayAfter": "Послезавтра",
  "prize.success.title": "Hero's Week активирован",
  "prize.success.body":
    "Мы привязали подарок к выбранному залу и дате. Скачай приложение и заходи по своему номеру — приз уже внутри.",
  "prize.success.done": "Готово",
  "prize.title": "Забрать Hero's Week",
  "prize.close": "Закрыть",
  "prize.intro": "Выбери зал и день, с которого хочешь начать тренировки.",
  "prize.clubLabel": "Зал",
  "prize.loadingClubs": "Загружаем залы…",
  "prize.clubsEmpty": "Список залов пуст",
  "prize.cityOther": "Другие города",
  "prize.startDateLabel": "Дата старта",
  "prize.submit": "Активировать приз",
  "prize.submitting": "Активируем…",
  "prize.errNoClub": "Выбери зал",
  "prize.errNoDate": "Выбери дату старта",
  "prize.errLoadClubs": "Не удалось загрузить список залов",
  "prize.errGrantFailed": "Не удалось активировать приз, попробуй ещё раз",
  "prize.errGrant": "Не удалось активировать приз",
  "prize.gift.title": "Подарочный Hero's Week",
  "prize.gift.intro": "Ты уже наш клиент — поэтому получаешь подарочный Hero's Week.",
  "prize.gift.note":
    "Это сертификат-подарок: он появится в твоём аккаунте Hero's Journey. Активировать можно в течение 3 месяцев — зал и дату старта выберешь при активации.",
  "prize.gift.claim": "Получить подарок",
  "prize.gift.success.title": "Подарок твой 🎁",
  "prize.gift.success.body":
    "Подарочный Hero's Week добавлен в твой аккаунт Hero's Journey. Активируй его в течение 3 месяцев.",

  // ---- MemberList.tsx ----
  "members.title": "Состав",
  "members.fallbackName": "Участник",
  "members.unknownInitial": "?",
  "members.leader": "Лидер",
  "members.empty": "В клане пока никого нет",

  // ---- MemberSlots.tsx ----
  "slots.member": "Участник {n}",
  "slots.remove": "Удалить",
  "slots.add": "+ Добавить участника",

  // ---- TaskList.tsx ----
  "tasks.title": "Задания",
  "tasks.progress": "{done} из {total}",
  "tasks.empty": "Заданий пока нет",

  // ---- ScoreRing.tsx ----
  "score.outOf": "из {max}",

  // ---- Faq.tsx + faq items ----
  "faq.title": "Вопросы и ответы",
  "faq.q1": "Как получить тренировки?",
  "faq.a1": "Войдите в приложение по этому же номеру телефона — подарок уже внутри.",

  // ---- Backend error codes ----
  "error.generic": "Что-то пошло не так, попробуй ещё раз",
  "error.existing_client":
    "Этот номер уже есть в нашей базе — приз только для новых гостей.",
  "error.nick_taken": "Этот ник уже занят — выбери другой",
  "error.already_in_clan": "Ты уже состоишь в клане",
  "error.clan_not_found": "Клан с таким кодом не найден — проверь код",
  "error.not_eligible":
    "Чтобы забрать приз, сначала выполни задания клана или пройди станцию гребли.",
  "error.bad_start_date": "Выбери корректную дату старта.",
  "error.no_hw_event_for_date": "На эту дату нет занятий — выбери другой день.",
  "error.rate_limited": "Слишком много попыток. Подожди минуту и попробуй снова.",
  "error.forbidden_for_role": "Это задание подтверждает другой ответственный.",
  "error.not_registered":
    "Гость с этим номером ещё не зарегистрирован на фестивале.",
};

const kk: Dict = {
  // ---- Language picker ----
  "lang.title": "Тілді таңда",
  "lang.subtitle": "Choose your language · Выбери язык",
  "lang.kk": "Қазақша",
  "lang.ru": "Русский",
  "lang.en": "English",

  // ---- Entry ----
  "entry.tagline":
    "Фестивальге тіркел, аймақтардан өт және жүлдеңді ал — Hero's Week бір апталық жаттығулары.",
  "entry.register": "Тіркелу",
  "entry.login": "Кіру",
  "entry.title": "Hero's Journey OYU Fest-те",
  "entry.subtitle": "Аймақтардан өт — жүлделерді ал",
  "entry.dates": "4 шілде 13:00 — 5 шілде 21:00",
  "register.fromLogin": "Бұл нөмірмен аккаунт табылмады. Деректерді толтыр да, қатыс!",
  "entry.zone1.note": "Бас жүлде — Hero's Journey-ден жарты жылдық абонемент",
  "entry.zone2.note": "Май мен бұлшықет пайызыңды біл",
  "entry.zone3.note": "Барлық тапсырманы орында — құны 9 990 тг болатын 3 сынақ жаттығуын ал",
  "entry.zone1.desc":
    "Есу тренажёрінде 30 секунд. Әйелдер мен ерлер арасындағы топ-3 — жарты жылға дейінгі абонементтер және Red Bull мерчі.",
  "entry.zone2.desc": "Тегін InBody дене құрамын өлшеу.",
  "entry.zone3.desc": "Клан жина да, тапсырмаларды бірге орында.",
  "entry.hw":
    "Жүлде қоры — баламасы 1 000 000 ₸-ден астам! Hero's Journey белсенділіктеріне қатысып, тапсырмаларды орындағаның үшін кепілді жүлделер ал.",
  "entry.prizesLink": "Жүлделер туралы толығырақ",
  "entry.cta": "Қатысу",
  "entry.haveAccount": "Менде аккаунт бар",

  // ---- Prizes.tsx ----
  "tab.prizes": "Жүлделер",
  "prizes.title": "Фестиваль жүлделері",
  "prizes.subtitle": "OYU Fest-те не ұтып алуға болады",
  "prizes.schedule.title": "Жарыстар қашан өтеді",
  "prizes.schedule.body":
    "Қатысу — 4 шілде 13:00-ден 5 шілде 21:00-ге дейін. Жеңімпаздардың нәтижелері қосымшада көрінеді, ал қорытындыны жарыстар аяқталған соң @herosjourneykz сторисінде жариялаймыз.",
  "prizes.rules.title": "Жүлде ережелері",
  "prizes.rules.body":
    "Ұтып алған жүлделер мен абонементтер жеке тіркеледі: үшінші тұлғаларға беруге және қайта сатуға болмайды.",
  "prizes.back": "Артқа",
  "prizes.rowing.title": "1-аймақ — «Қуатыңды біл»",
  "prizes.rowing.how":
    "Есу тренажёрінде 30 секунд жұмыс — қашықтық ваттқа айналады. Әйелдер мен ерлер бөлек есептеледі.",
  "prizes.rowing.women": "Әйелдер",
  "prizes.rowing.men": "Ерлер",
  "prizes.place1": "Жарты жылдық абонемент + Red Bull мерчі",
  "prizes.place2": "Бір айлық екі абонемент (өзіңе және досыңа) + Hero's Journey сөмкесі",
  "prizes.place3": "Бір айлық абонемент",
  "prizes.hw.title": "Hero's Week — қатысқаны үшін",
  "prizes.hw.body":
    "Есуге қатыс немесе клан тапсырмаларын орында — Hero's Journey-де 3 тегін жаттығу ал.",
  "prizes.hwGift.title": "Сыйлық Hero's Week",
  "prizes.hwGift.body":
    "Сен бізбен бірге болғансың! Фестивальге қатысқаның үшін сыйлық Hero's Week сыйлаймыз — бір апталық жаттығу сертификаты. 3 ай ішінде белсендіруге болады.",
  "prizes.inbody.title": "2-аймақ — «Денеңді цифрла»",
  "prizes.inbody.body":
    "InBody өлшемінің нәтижесі осы веб-сервисте көрінеді. Май мен бұлшықет пайызының толық талдауы — Hero's Journey қосымшасында.",
  "prizes.clan.title": "3-аймақ — «Кландар шайқасы»",
  "prizes.clan.body": "Тапсырмаларды бүкіл командамен орындаңдар — әрқайсысы Hero's Week алады. Тапсырмалар тізімі — «Кландар» қойындысында.",

  // ---- Stations.tsx: жүлде жолдары ----
  "stations.rowing.prize": "🏆 Топ-3 — абонементтер мен мерч, барлық қатысушыларға — Hero's Week",
  "stations.inbody.prize": "📱 Толық талдау — Hero's Journey қосымшасында",
  "stations.battle.prize": "🎁 Тапсырмаларды орында — Hero's Week ал",

  // ---- Rowing.tsx ----
  "rowing.myResult": "Менің нәтижем",
  "rowing.lbTitle": "Лидерборд",
  "rowing.noRows": "Әзірге нәтижелер жоқ — бірінші бол!",
  "rowing.motivation": "1-орын — жарты жылдық абонемент + Red Bull мерчі. Қаттырақ есе!",

  // ---- Register ----
  "register.title": "Тіркелу",
  "register.subtitle":
    "Нөмірің мен атыңды қалдыр — Hero's Journey белсенділіктеріне қатысып, жүлдені алу үшін осы жеткілікті.",
  "register.phoneLabel": "Телефон",
  "register.nickLabel": "Лақап ат (латынша, бос орынсыз)",
  "register.nickPlaceholder": "Мысалы: hero_77",
  "register.submit": "Тіркелу",
  "register.submitting": "Тіркеудеміз…",
  "register.haveAccount": "Менде тіркелу бар",
  "register.dobLabel": "Туған күнің",
  "register.dobPlaceholder": "КК.АА.ЖЖЖЖ",
  "register.dob.day": "КК",
  "register.dob.month": "АА",
  "register.dob.year": "ЖЖЖЖ",
  "register.dob.note": "Жарыстарға 16 жастан бастап қатысуға болады.",
  "register.dob.confirm": "Растау",
  "register.errNoDob": "Туған күніңді көрсет",
  "register.errBadDate": "Туған күніңді тексер",
  "register.errUnderage": "Жарыстарға 16 жастан бастап қатысуға болады",
  "register.sexLabel": "Жыныс",
  "register.sexF": "Әйел",
  "register.sexM": "Ер",
  "register.errNoSex": "Жынысты таңда",
  "register.errInvalidPhone": "Телефон нөміріңді тексер",
  "register.errNoNick": "Лақап атыңды енгіз",
  "register.errNickLatin": "Лақап ат — тек латын әріптері, сандар және _, бос орынсыз (2–20 таңба)",
  "register.existing.title": "Сен біздің клиентімізсің",
  "register.existing.body":
    "Фестиваль жүлдесі — тек Hero's Journey-дің жаңа қонақтарына арналған. Бұл нөмір біздің базада бар, сондықтан оған жүлде берілмейді. Бірақ сен бәрібір фестивальге келіп, достарыңды қолдай аласың!",
  "register.existing.otherNumber": "Басқа нөмір енгізу",
  "register.existing.home": "Басты бетке",

  // ---- Login ----
  "login.title": "Кіру",
  "login.subtitle": "Тіркелген телефон нөміріңді енгіз.",
  "login.phoneLabel": "Телефон",
  "login.submit": "Кіру",
  "login.submitting": "Тексерудеміз…",
  "login.errInvalidPhone": "Нөмір қате",
  "otp.title": "Кодты енгізіңіз",
  "otp.subtitle": "Растау кодын SMS арқылы жібердік.",
  "otp.codeLabel": "SMS-тегі код",
  "otp.codePlaceholder": "0000",
  "otp.getCode": "Кодты алу",
  "otp.sending": "Жіберудеміз…",
  "otp.verify": "Кіру",
  "otp.verifying": "Тексерудеміз…",
  "otp.resend": "Кодты қайта жіберу",
  "otp.errBadCode": "Код қате",
  "login.notFound.title": "Сені таппадық",
  "login.notFound.body":
    "Бұл нөмірмен әзірге тіркелу жоқ. Тіркел — бұл бір минут алады.",
  "login.notFound.register": "Тіркелу",
  "login.notFound.otherNumber": "Басқа нөмір енгізу",

  // ---- Hub ----
  "hub.greeting": "Сәлем, {name}!",
  "hub.greetingFallback": "батыр",
  "hub.subtitle": "Hero's Journey фестиваліндегі штабың",
  "hub.live": "live",
  "hub.loading": "Жүктеудеміз…",
  "hub.backToLogin": "Кіруге",
  "hub.progress.title": "Фестиваль прогресі",
  "hub.progress.count": "{done} / 3 аймақ",
  "hub.rowing.zone": "1-аймақ",
  "hub.zoneLocked.rowing": "Есу жарысы — Hero's Journey-дің жаңа қонақтарына арналған.",
  "hub.zoneLocked.inbody": "Тегін InBody өлшеу — Hero's Journey-дің жаңа қонақтарына арналған.",
  "hub.zoneLocked.friend":
    "💪 HJ-де әлі болмаған досыңды әкел — ол жарты жылдық абонемент ұтып ала алады!",
  "hub.rowing.metric": "Қашықтық · қуат {power} Вт",
  "hub.clan.notReady":
    "Клан дайын саналуы үшін кемінде 3 қатысушы керек. Қазір: {count}. Достарыңды {code} коды арқылы шақыр.",
  "hub.clan.title": "Кландар шайқасы",
  "hub.clan.body":
    "Қалауыңша: клан құр немесе код арқылы кір де, тапсырмаларды бірге орында. Жүлдені жалғыз да алуға болады — есу станциясы арқылы.",
  "hub.clan.bodyGift":
    "Клан жина немесе код арқылы кір де, тапсырмаларды бірге орындаңдар — досыңа сыйлық Hero's Week аласың.",
  "hub.clan.create": "Клан құру",
  "hub.clan.join": "Код арқылы кіру",
  "hub.rowing.title": "Қуатыңды біл",
  "hub.rowing.distance": "Қашықтық",
  "hub.rowing.power": "Қуат",
  "hub.rowing.empty":
    "Фестивальдегі есу станциясына кел — нәтижең осында пайда болады.",
  "hub.inbody.title": "Денеңді цифрла",
  "hub.inbody.pbf": "Май %",
  "hub.inbody.cta": "Толық талдау — қосымшада →",
  "hub.inbody.empty":
    "Станцияда (2-аймақ) InBody тест тапсыр — нәтижеңді осында көресің.",
  "hub.prize.label": "Жүлде — Hero's Week",
  "hub.prize.value": "3 жаттығу тегін",
  "hub.prize.granted": "Hero's Week белсендірілді 🎉",
  "hub.prize.claim": "Hero's Week алу",
  "hub.prize.locked":
    "Жүлдені алу үшін — клан тапсырмаларын орында немесе есу станциясынан өт.",
  "hub.noPhone": "Телефон нөмірі жоқ",

  // ---- Tab bar ----
  "tab.home": "Басты",
  "tab.stations": "Аймақтар",
  "tab.clans": "Кландар",
  "tab.profile": "Профиль",

  // ---- Stations ----
  "stations.title": "Фестиваль аймақтары",
  "stations.subtitle": "Фестивальдегі Hero's Journey аймақтары",
  "stations.zonePrefix": "{n}-аймақ",
  "stations.rowing.title": "Қуатыңды біл",
  "stations.rowing.desc": "Есу станциясына кел — нәтиже штабта пайда болады.",
  "stations.rowing.doneDesc": "Нәтиже жазылды: {distance} м · {power} Вт.",
  "stations.inbody.title": "Денеңді сканерле",
  "stations.inbody.desc": "Станцияда (2-аймақ) дене құрамын өлшет.",
  "stations.inbody.doneDesc": "Өлшем дайын — штабтан «Менің дене құрамым» бөлімін аш.",
  "stations.battle.title": "Кландар шайқасы",
  "stations.battle.desc": "Клан құр немесе код арқылы кір де, тапсырмаларды бірге орында.",
  "stations.battle.doneDesc": "Сен «{name}» кланындасың — тапсырмалар: {done}/{total}.",
  "stations.status.done": "Өтілді",
  "stations.status.pending": "Сені күтеді",

  // ---- Profile ----
  "profile.title": "Профиль",
  "profile.phoneLabel": "Телефон",
  "profile.nickLabel": "Лақап ат",
  "profile.nickSave": "Сақтау",
  "profile.nickSaving": "Сақталуда…",
  "profile.nickSaved": "Лақап ат жаңартылды ✓",
  "profile.langLabel": "Тіл",
  "profile.statusTitle": "Менің статусым",
  "profile.status.clanIn": "«{name}» кланындасың",
  "profile.status.clanNone": "Әзірге клансыз",
  "profile.status.prizeGranted": "Hero's Week жүлдесі белсендірілді",
  "profile.status.prizeEligible": "Жүлде дайын — штабтан ал",
  "profile.status.prizeLocked": "Жүлде әлі ашылмаған",
  "profile.toHub": "Штабқа",
  "profile.logout": "Шығу",

  // units
  "unit.meters": "м",
  "unit.watts": "Вт",
  "unit.percent": "%",

  // ---- Clan ----
  "clan.noPhone": "Телефон нөмірі жоқ",
  "clan.back": "Артқа",
  "clan.createTitle": "Клан құру",
  "clan.joinTitle": "Код арқылы кіру",
  "clan.nameLabel": "Клан атауы",
  "clan.namePlaceholder": "Мысалы: Tigers",
  "clan.mottoLabel": "Ұран (міндетті емес)",
  "clan.mottoPlaceholder": "Барлығы біреу үшін",
  "clan.emojiLabel": "Эмодзи (міндетті емес)",
  "clan.codeLabel": "Клан коды",
  "clan.codePlaceholder": "Мысалы, TIGR12",
  "clan.codeHint": "Кодты саған клан көшбасшысы береді.",
  "clan.create": "Клан құру",
  "clan.creating": "Құрудамыз…",
  "clan.join": "Кіру",
  "clan.joining": "Кірудеміз…",
  "clan.errNoName": "Клан атауын енгіз",
  "clan.errNameLatin": "Клан атауы — тек латын әріптері, сандар мен бос орындар (2–24 таңба)",
  "clan.errNoCode": "Клан кодын енгіз",
  "clan.errAlreadyIn": "Сен қазірдің өзінде клан мүшесісің",
  "clan.errCreateFailed": "Клан құру мүмкін болмады",
  "clan.errJoinFailed": "Кланға кіру мүмкін болмады",
    "task.header": "Тапсырма",
  "task.logo_story.title": "«HJ» топтық фотосы",
  "task.logo_story.desc":
    "Денелеріңмен «HJ» әріптерін бейнелеп, топтық фото түсіріңдер. Кланның әр қатысушысы фотоны сторисқа салып, @herosjourneykz және @oyu.fest аккаунттарын белгілейді.",
  "task.story.instaLabel": "Сенің Instagram-ың",
  "task.story.instaPh": "@username",
  "task.story.checkbox": "Сторис салдым және екі аккаунтты белгіледім",
  "task.story.submit": "Тексеруге жіберу",
  "task.story.submitting": "Жіберілуде…",
  "task.story.pending": "⏳ Тапсырма тексерілуде",
  "task.story.pendingHint": "Модератор стористі тексеріп, орындалғанын есептейді.",
  "task.story.approved": "Орындалды 🎉",
  "task.story.progress": "Орындады: {done} / {total}",
  "task.story.needClan": "Бұл клан тапсырмасы — алдымен клан құр немесе код арқылы кір.",
  "task.story.errNoInsta": "Instagram-ыңды көрсет",
  "task.story.st.pending": "тексерілуде",
  "task.story.st.none": "әлі салған жоқ",
  "task.story.st.approved": "орындалды",
  "task.group_plank.title": "Топтық планка",
  "task.group_plank.desc":
    "Алаңнан Hero's Journey жаттықтырушысын тап. Оның белгісімен бүкіл командамен қол ұстасып, арқаларыңды бір-біріңе тіреп «орындық» планкасына тұрыңдар да, 2 минут шыдаңдар. Жаттықтырушы уақытты қадағалап, орындалған соң тапсырманы есептейді.",
  "task.redbull_activity.title": "Red Bull аймағындағы белсенділік",
  "task.redbull_activity.desc":
    "Серіктесіміз Red Bull аймағында кез келген активитиден бүкіл кланмен өтіңдер. Аймақ қызметкері орындалғанын белгілейді. Сторис бөліссең — @redbullkazakhstan аккаунтын белгіле!",
  "clan.tasksTitle": "Клан тапсырмалары",
  "clan.tasksIntro": "Бүкіл командамен орындаңдар — әрқайсысы Hero's Week алады:",
  "clan.list.title": "Фестиваль кландары",
  "clan.list.empty": "Әзірге бірде-бір клан жоқ — алғашқысын құр!",
  "clan.list.yours": "Сенің кланың",
  "clan.list.members": "Қатысушылар: {count}",
  "clan.list.tasks": "Тапсырмалар: {done}/{total}",
  "clan.list.completed": "Барлық тапсырма",

  // ---- Coach ----
  "coach.title": "Жаттықтырушы панелі",
  "coach.title.coach": "Жаттықтырушы панелі",
  "coach.title.marketing": "Маркетинг панелі",
  "coach.title.redbull": "Red Bull панелі",
  "coach.title.admin": "Стафф панелі",
  "coach.tab.clans": "Кландар",
  "coach.myTaskProgress": "Сенің тапсырмаң {total} кланның {done}-інде белгіленген",
  "coach.rowing.recent": "Соңғы енгізілгендер",
  "coach.board.hint": "Әр зачёттің топ-5-і. Қорытынды — жарыстар аяқталған соң, 5 шілдеде.",
  "coach.rowing.nickLabel": "Қатысушының лақап аты",
  "coach.rowing.nickPlaceholder": "hero_77",
  "coach.rowing.orPhoneLabel": "…немесе телефоны",
  "coach.rowing.errWho": "Қатысушының лақап атын немесе телефонын көрсет",
  "coach.rowing.errNickUnsupported":
    "Сервер лақап ат бойынша жазуды әзірге қабылдамайды — қатысушының телефон нөмірін енгіз",
  "coach.rowing.editHint": "Сол қатысушыға қайта жазу нәтижені ауыстырады — қатені осылай түзетуге болады. Қатысушыны қою үшін «Соңғы енгізілгендер» жолын бас.",
  "error.participant_not_found": "Қатысушы табылмады — лақап атын немесе нөмірін тексер",
  "coach.tab.rowing": "Есу",
  "coach.prizeGranted": "жүлде берілді",
  "coach.ready": "дайын",
  "coach.leader": "Көшбасшы: {name}",
  "coach.members": "Қатысушылар: {count} · Тапсырмалар: {done}/{total}",
  "coach.noTasks": "Тапсырмалар жоқ",
  "coach.searchPlaceholder": "Клан атауы немесе көшбасшы бойынша іздеу",
  "coach.nothingFound": "Ештеңе табылмады",
  "coach.noClans": "Әзірге кландар жоқ",
  "coach.errLoadClans": "Кландарды жүктеу мүмкін болмады",
  "coach.errCheck": "Тапсырманы белгілеу мүмкін болмады",
  "coach.rowing.recordTitle": "Нәтижені жазу",
  "coach.rowing.guestPhone": "Қонақтың телефоны",
  "coach.rowing.distanceLabel": "Қашықтық, м",
  "coach.rowing.distancePlaceholder": "мысалы, 500",
  "coach.rowing.save": "Нәтижені жазу",
  "coach.rowing.saving": "Сақтаудамыз…",
  "coach.rowing.distance": "Қашықтық",
  "coach.rowing.power": "Қуат",
  "coach.rowing.leaderboard": "Көшбасшылар тақтасы",
  "coach.rowing.guestFallback": "Қонақ",
  "coach.rowing.boardEmpty": "Әзірге нәтижелер жоқ",
  "coach.rowing.errPhone": "Телефон нөмірін тексер",
  "coach.rowing.errDistance": "Қашықтықты метрмен енгіз",
  "coach.rowing.errSave": "Нәтижені жазу мүмкін болмады",
  "coach.rowing.errBoard": "Көшбасшылар тақтасын жүктеу мүмкін болмады",
  "lb.title": "Лидерборд · Қуатыңды біл",
  "lb.live": "эфирде",
  "lb.updated": "Жаңартылды",
  "lb.participants": "Қатысушылар: {n}",
  "lb.total": "Барлығы бірге {km} км ескек тартты",
  "lb.offline": "байланыс жоқ",
  "lb.women": "Әйелдер",
  "lb.men": "Ерлер",
  "lb.spotlight.recorded": "Нәтиже жазылды!",
  "lb.spotlight.placeWomen": "Әйелдер арасында {rank}-орын",
  "lb.spotlight.placeMen": "Ерлер арасында {rank}-орын",
  "lb.spotlight.overall": "Жалпы есепте {rank}-орын",
  "staff.title": "Қызметтік экран",
  "staff.subtitle": "Кіру кодын енгіз. Оны ұйымдастырушы береді.",
  "staff.placeholder": "Кіру коды",
  "staff.submit": "Кіру",
  "staff.checking": "Тексерудеміз…",
  "staff.error": "Қате код",
  "staff.youAre": "Сіз: {role}",
  "admin.title": "Әкімші панелі",
  "admin.tab.stats": "Статистика",
  "admin.tab.tasks": "Тапсырмалар",
  "admin.tab.winners": "Жеңімпаздар",
  "admin.tab.stories": "Сторис",
  "admin.story.title": "Сторис тексеру",
  "admin.story.empty": "Өтінімдер әзірге жоқ",
  "admin.story.pendingCount": "күтуде: {n}",
  "admin.story.approve": "Есептеу",
  "admin.story.reject": "Қабылдамау",
  "admin.story.pending": "тексерілуде",
  "admin.story.approved": "есептелді",
  "admin.winners.women": "Топ-3 — әйелдер",
  "admin.winners.men": "Топ-3 — ерлер",
  "admin.winners.empty": "Әзірге нәтиже жоқ",
  "admin.winners.hint": "Ескек тартудың финалдық топы. Жүлдені беру үшін жеңімпаздармен байланысыңыз.",
  "admin.forbidden": "Тек ұйымдастырушыға рұқсат.",
  "admin.refresh": "Жаңарту",
  "admin.stat.participants": "Тіркелулер",
  "admin.stat.menWomen": "Е {men} · Ә {women} · көрсетілмеген {other}",
  "admin.stat.clans": "Кландар",
  "admin.stat.clansSub": "дайын {ready} · аяқтады {completed}",
  "admin.stat.members": "Клан мүшелері",
  "admin.stat.rowing": "Ескек есу",
  "admin.stat.rowingSub": "нәтиже · жүлдемен {prize}",
  "admin.stat.top": "Көшбасшы: {name} · {power} Вт",
  "admin.stat.prizes": "Hero's Week берілді",
  "admin.stat.tasksTitle": "Тапсырмалардың орындалуы",
  "admin.stat.clansDone": "{n} клан",
  "admin.empty": "—",
  "admin.tab.rowing": "Есу",
  "admin.rowing.hint": "Есудің барлық нәтижесі: {n}",
  "admin.rowing.empty": "Әзірге бірде-бір нәтиже жоқ.",
  "admin.rowing.page": "{n} беттің {p}-і",
  "admin.rowing.noPhones": "Телефондар бэкенд /admin/rowing бере бастағанда шығады.",
  "admin.rowing.f": "Ә",
  "admin.rowing.m": "Е",
  "admin.inbody.title": "InBody өткендер",
  "admin.inbody.empty": "Әзірге ешкім өлшемнен өткен жоқ.",
  "admin.inbody.unavailable": "Тізім бэкенд /admin/inbody бере бастағанда шығады.",
  "admin.task.listTitle": "Барлық тапсырмалар",
  "admin.task.newTitle": "Жаңа тапсырма",
  "admin.task.titleLabel": "Тапсырма атауы",
  "admin.task.titlePh": "Клан не істеуі керек",
  "admin.task.roleLabel": "Растайды",
  "admin.task.active": "Белсенді",
  "admin.task.sort": "Реті",
  "admin.task.create": "Тапсырма құру",
  "admin.task.save": "Сақтау",
  "admin.task.saving": "Сақтаудамыз…",
  "admin.task.off": "өшірулі",
  "admin.task.errSave": "Сақтау мүмкін болмады",
  "admin.task.errLoad": "Жүктеу мүмкін болмады",
  "staff.role.admin": "Ұйымдастырушы",
  "staff.role.marketing": "Маркетинг",
  "staff.role.coach": "Жаттықтырушы",
  "staff.role.redbull": "RedBull",

  // ---- InBody ----
  "inbody.back": "Артқа",
  "inbody.title": "Денеңді цифрла",
  "inbody.loading": "Жүктеудеміз…",
  "inbody.empty": "Станцияда (2-аймақ) InBody тест тапсыр — нәтиже осында пайда болады.",
  "inbody.appPrompt": "Hero's Journey қосымшасын жүктеп, өз нөміріңмен кір — өлшемнің толық нәтижелері (салмақ, бұлшықет, май, метаболизм) сонда шығады.",
  "inbody.score": "InBody балы",
  "inbody.measuredAt": "Өлшем: {date}",
  "inbody.about.title": "InBody деген не",
  "inbody.about.body":
    "InBody — дене құрамын талдағыш. Платформаға тұрып, тұтқалардан ұстайсың — 60 секундтан кейін құрал денеңнің неден тұратынын көрсетеді. Жалпы салмақ емес, толық талдау: қанша бұлшықет, қанша май, май нақты қай жерде және тіндерде қанша су бар. Құрал дене арқылы әлсіз, қауіпсіз ток өткізеді — бұлшықет, май және су оны әртүрлі өткізеді, бүкіл көрініс осы айырмашылыққа құрылады. Әдіс биоимпеданс деп аталады, оны бүкіл әлемдегі клиникалар мен спорт командалары қолданады.",
  "inbody.metabolicAge": "Метаболикалық жас",
  "inbody.pbf": "Май %",
  "inbody.ctaQuestion":
    "Толық талдауды көргің келе ме — салмақ, бұлшықет, висцералды май және метаболизм?",
  "inbody.ctaHint": "Толық есепті Hero's Journey қосымшасынан аш",
  "inbody.download": "Қосымшаны жүктеу",

  // ---- Done ----
  "done.title": "Барлық тапсырма орындалды!",
  "done.subtitle": "Кланың жүлдені алды — Hero's Week бағдарламасы бойынша 3 жаттығу.",
  "done.appHintWithPhone":
    "Hero's Journey қосымшасын жүктеп ал да, {phone} нөмірімен кір — сыйлық сол жерде.",
  "done.appHintNoPhone":
    "Hero's Journey қосымшасын жүктеп ал да, телефон нөміріңмен кір — сыйлық сол жерде.",
  "done.appStore": "App Store-дан жүктеу",
  "done.googlePlay": "Google Play-ден жүктеу",
  "done.linksSoon": "Қосымшаға сілтемелер жақында пайда болады.",

  // ---- PrizeModal ----
  "prize.today": "Бүгін",
  "prize.tomorrow": "Ертең",
  "prize.dayAfter": "Арғы күні",
  "prize.success.title": "Hero's Week белсендірілді",
  "prize.success.body":
    "Сыйлықты таңдаған залың мен күніңе байладық. Қосымшаны жүктеп ал да, өз нөміріңмен кір — жүлде сол жерде.",
  "prize.success.done": "Дайын",
  "prize.title": "Hero's Week алу",
  "prize.close": "Жабу",
  "prize.intro": "Залды және жаттығуды бастағың келетін күнді таңда.",
  "prize.clubLabel": "Зал",
  "prize.loadingClubs": "Залдарды жүктеудеміз…",
  "prize.clubsEmpty": "Залдар тізімі бос",
  "prize.cityOther": "Басқа қалалар",
  "prize.startDateLabel": "Басталу күні",
  "prize.submit": "Жүлдені белсендіру",
  "prize.submitting": "Белсендірудеміз…",
  "prize.errNoClub": "Залды таңда",
  "prize.errNoDate": "Басталу күнін таңда",
  "prize.errLoadClubs": "Залдар тізімін жүктеу мүмкін болмады",
  "prize.errGrantFailed": "Жүлдені белсендіру мүмкін болмады, қайталап көр",
  "prize.errGrant": "Жүлдені белсендіру мүмкін болмады",
  "prize.gift.title": "Сыйлық Hero's Week",
  "prize.gift.intro": "Сен біздің клиентімізсің — сондықтан сыйлық Hero's Week аласың.",
  "prize.gift.note":
    "Бұл — сыйлық-сертификат: ол сенің Hero's Journey аккаунтыңда пайда болады. 3 ай ішінде белсендіруге болады — залды және бастау күнін белсендіру кезінде таңдайсың.",
  "prize.gift.claim": "Сыйлықты алу",
  "prize.gift.success.title": "Сыйлық сенікі 🎁",
  "prize.gift.success.body":
    "Сыйлық Hero's Week сенің Hero's Journey аккаунтыңа қосылды. 3 ай ішінде белсендір.",

  // ---- MemberList ----
  "members.title": "Құрам",
  "members.fallbackName": "Қатысушы",
  "members.unknownInitial": "?",
  "members.leader": "Көшбасшы",
  "members.empty": "Кланда әзірге ешкім жоқ",

  // ---- MemberSlots ----
  "slots.member": "{n}-қатысушы",
  "slots.remove": "Жою",
  "slots.add": "+ Қатысушы қосу",

  // ---- TaskList ----
  "tasks.title": "Тапсырмалар",
  "tasks.progress": "{total} ішінен {done}",
  "tasks.empty": "Әзірге тапсырмалар жоқ",

  // ---- ScoreRing ----
  "score.outOf": "{max} ішінен",

  // ---- Faq ----
  "faq.title": "Сұрақтар мен жауаптар",
  "faq.q1": "Жаттығуларды қалай аламын?",
  "faq.a1": "Қосымшаға дәл осы телефон нөмірімен кір — сыйлық сол жерде.",

  // ---- Backend error codes ----
  "error.generic": "Бірдеңе дұрыс болмады, қайталап көр",
  "error.existing_client":
    "Бұл нөмір біздің базада бар — жүлде тек жаңа қонақтарға арналған.",
  "error.nick_taken": "Бұл лақап ат бос емес — басқасын таңда",
  "error.already_in_clan": "Сен қазірдің өзінде клан мүшесісің",
  "error.clan_not_found": "Мұндай кодпен клан табылмады — кодты тексер",
  "error.not_eligible":
    "Жүлдені алу үшін алдымен клан тапсырмаларын орында немесе есу станциясынан өт.",
  "error.bad_start_date": "Дұрыс басталу күнін таңда.",
  "error.no_hw_event_for_date": "Бұл күнге сабақ жоқ — басқа күнді таңда.",
  "error.rate_limited": "Тым көп әрекет. Бір минут күтіп, қайталап көр.",
  "error.forbidden_for_role": "Бұл тапсырманы басқа жауапты адам растайды.",
  "error.not_registered":
    "Бұл нөмірдегі қонақ фестивальге әлі тіркелмеген.",
};

const en: Dict = {
  // ---- Language picker ----
  "lang.title": "Choose your language",
  "lang.subtitle": "Тілді таңда · Выбери язык",
  "lang.kk": "Қазақша",
  "lang.ru": "Русский",
  "lang.en": "English",

  // ---- Entry ----
  "entry.tagline":
    "Register at the festival, complete the zones and claim your prize — a week of Hero's Week training.",
  "entry.register": "Register",
  "entry.login": "Log in",
  "entry.title": "Hero's Journey at OYU Fest",
  "entry.subtitle": "Complete the zones — grab the prizes",
  "entry.dates": "July 4, 13:00 — July 5, 21:00",
  "register.fromLogin": "No account found with this number. Fill in your details to join!",
  "entry.zone1.note": "Grand prize — a six-month Hero's Journey membership",
  "entry.zone2.note": "Learn your fat and muscle percentage",
  "entry.zone3.note": "Complete all tasks — get 3 trial workouts worth 9,990 KZT",
  "entry.zone1.desc":
    "30 seconds on a rowing machine. Top 3 among women and men win memberships up to six months plus Red Bull merch.",
  "entry.zone2.desc": "Free InBody body composition scan.",
  "entry.zone3.desc": "Build a clan and complete the tasks together.",
  "entry.hw":
    "A prize pool worth over 1,000,000 ₸! Join the Hero's Journey activities and earn guaranteed prizes for completing the tasks.",
  "entry.prizesLink": "More about prizes",
  "entry.cta": "Join now",
  "entry.haveAccount": "I already have an account",

  // ---- Prizes.tsx ----
  "tab.prizes": "Prizes",
  "prizes.title": "Festival prizes",
  "prizes.subtitle": "What you can win at OYU Fest",
  "prizes.schedule.title": "When the competitions run",
  "prizes.schedule.body":
    "Competitions are open from July 4, 13:00 until July 5, 21:00. Winners' results appear in the app, and we'll announce the final standings in @herosjourneykz stories after the competitions end.",
  "prizes.rules.title": "Prize rules",
  "prizes.rules.body":
    "Won prizes and memberships are personal: transferring them to third parties or reselling is not allowed.",
  "prizes.back": "Back",
  "prizes.rowing.title": "Zone 1 — Know your power",
  "prizes.rowing.how":
    "30 seconds of work on a rowing machine — distance turns into watts. Separate rankings for women and men.",
  "prizes.rowing.women": "Women",
  "prizes.rowing.men": "Men",
  "prizes.place1": "Six-month membership + Red Bull merch",
  "prizes.place2": "Two one-month memberships (for you and a friend) + Hero's Journey bag",
  "prizes.place3": "One-month membership",
  "prizes.hw.title": "Hero's Week for taking part",
  "prizes.hw.body":
    "Take part in the rowing or complete the clan tasks — and get 3 free workouts at Hero's Journey.",
  "prizes.hwGift.title": "Gift Hero's Week",
  "prizes.hwGift.body":
    "You're already with us! For taking part in the festival we're gifting you a Hero's Week — a certificate for a week of workouts. Activate it within 3 months.",
  "prizes.inbody.title": "Zone 2 — Digitize your body",
  "prizes.inbody.body":
    "Your InBody scan result appears here in the web service. The detailed fat and muscle breakdown is in the Hero's Journey app.",
  "prizes.clan.title": "Zone 3 — Battle of Clans",
  "prizes.clan.body": "Complete the tasks as a team — everyone gets Hero's Week. The task list lives in the Clans tab.",

  // ---- Stations.tsx: prize lines ----
  "stations.rowing.prize": "🏆 Top 3 — memberships and merch, Hero's Week for all participants",
  "stations.inbody.prize": "📱 Detailed breakdown — in the Hero's Journey app",
  "stations.battle.prize": "🎁 Complete the tasks — get Hero's Week",

  // ---- Rowing.tsx ----
  "rowing.myResult": "My result",
  "rowing.lbTitle": "Leaderboard",
  "rowing.noRows": "No results yet — be the first!",
  "rowing.motivation": "1st place takes a six-month membership + Red Bull merch. Row harder!",

  // ---- Register ----
  "register.title": "Registration",
  "register.subtitle":
    "Leave your phone number and name — that's all it takes to join the Hero's Journey activities and claim your prize.",
  "register.phoneLabel": "Phone",
  "register.nickLabel": "Nickname (Latin, no spaces)",
  "register.nickPlaceholder": "e.g. hero_77",
  "register.submit": "Register",
  "register.submitting": "Registering…",
  "register.haveAccount": "I already have a registration",
  "register.dobLabel": "Date of birth",
  "register.dobPlaceholder": "DD.MM.YYYY",
  "register.dob.day": "DD",
  "register.dob.month": "MM",
  "register.dob.year": "YYYY",
  "register.dob.note": "You must be at least 16 to take part.",
  "register.dob.confirm": "Confirm",
  "register.errNoDob": "Enter your date of birth",
  "register.errBadDate": "Check your date of birth",
  "register.errUnderage": "You must be at least 16 to take part",
  "register.sexLabel": "Gender",
  "register.sexF": "Female",
  "register.sexM": "Male",
  "register.errNoSex": "Select your gender",
  "register.errInvalidPhone": "Check your phone number",
  "register.errNoNick": "Enter your nickname",
  "register.errNickLatin": "Latin letters, digits and _ only, no spaces (2–20 characters)",
  "register.existing.title": "You're already our client",
  "register.existing.body":
    "The festival prize is only for new Hero's Journey guests. This number is already in our database, so no prize for it. But you can still come to the festival and cheer on your friends!",
  "register.existing.otherNumber": "Enter another number",
  "register.existing.home": "Home",

  // ---- Login ----
  "login.title": "Log in",
  "login.subtitle": "Enter the phone number you registered with.",
  "login.phoneLabel": "Phone",
  "login.submit": "Log in",
  "login.submitting": "Checking…",
  "login.errInvalidPhone": "Invalid number",
  "otp.title": "Enter the code",
  "otp.subtitle": "We sent a confirmation code by SMS.",
  "otp.codeLabel": "SMS code",
  "otp.codePlaceholder": "0000",
  "otp.getCode": "Get code",
  "otp.sending": "Sending…",
  "otp.verify": "Log in",
  "otp.verifying": "Verifying…",
  "otp.resend": "Resend code",
  "otp.errBadCode": "Invalid code",
  "login.notFound.title": "We couldn't find you",
  "login.notFound.body":
    "There's no registration for this number yet. Register — it takes a minute.",
  "login.notFound.register": "Register",
  "login.notFound.otherNumber": "Enter another number",

  // ---- Hub ----
  "hub.greeting": "Hi, {name}!",
  "hub.greetingFallback": "hero",
  "hub.subtitle": "Your HQ at the Hero's Journey festival",
  "hub.live": "live",
  "hub.loading": "Loading…",
  "hub.backToLogin": "To log in",
  "hub.progress.title": "Festival progress",
  "hub.progress.count": "{done} / 3 zones",
  "hub.rowing.zone": "Zone 1",
  "hub.zoneLocked.rowing": "The rowing competition is for new Hero's Journey guests.",
  "hub.zoneLocked.inbody": "The free InBody scan is for new Hero's Journey guests.",
  "hub.zoneLocked.friend":
    "💪 Bring a friend who's new to HJ — they can win a six-month membership!",
  "hub.rowing.metric": "Distance · power {power} W",
  "hub.clan.notReady":
    "A clan needs at least 3 members to be ready. Now: {count}. Invite friends with the code {code}.",
  "hub.clan.title": "Battle of Clans",
  "hub.clan.body":
    "Optional: build a clan or join with a code and complete tasks together. You can also claim the prize solo — at the rowing station.",
  "hub.clan.bodyGift":
    "Build a clan or join with a code and complete the tasks together — you'll get a gift Hero's Week for a friend.",
  "hub.clan.create": "Create a clan",
  "hub.clan.join": "Join with a code",
  "hub.rowing.title": "Find Your Power",
  "hub.rowing.distance": "Distance",
  "hub.rowing.power": "Power",
  "hub.rowing.empty":
    "Head to the rowing station at the festival — your result will show up here.",
  "hub.inbody.title": "Digitize your body",
  "hub.inbody.pbf": "Body fat %",
  "hub.inbody.cta": "Full breakdown — in the app →",
  "hub.inbody.empty":
    "Take an InBody test at the station (Zone 2) — you'll see your result here.",
  "hub.prize.label": "Prize — Hero's Week",
  "hub.prize.value": "3 free workouts",
  "hub.prize.granted": "Hero's Week activated 🎉",
  "hub.prize.claim": "Claim Hero's Week",
  "hub.prize.locked":
    "To claim the prize — complete clan tasks or do the rowing station.",
  "hub.noPhone": "No phone number",

  // ---- Tab bar ----
  "tab.home": "Home",
  "tab.stations": "Zones",
  "tab.clans": "Clans",
  "tab.profile": "Profile",

  // ---- Stations ----
  "stations.title": "Festival zones",
  "stations.subtitle": "Hero's Journey zones at the festival",
  "stations.zonePrefix": "Zone {n}",
  "stations.rowing.title": "Find Your Power",
  "stations.rowing.desc": "Head to the rowing station — your result will appear in the HQ.",
  "stations.rowing.doneDesc": "Result recorded: {distance} m · {power} W.",
  "stations.inbody.title": "Scan Your Body",
  "stations.inbody.desc": "Get your body composition measured at the station (Zone 2).",
  "stations.inbody.doneDesc": "Measurement ready — open “My body composition” in the HQ.",
  "stations.battle.title": "Battle of Clans",
  "stations.battle.desc": "Build a clan or join with a code and complete tasks together.",
  "stations.battle.doneDesc": "You're in clan “{name}” — tasks: {done}/{total}.",
  "stations.status.done": "Completed",
  "stations.status.pending": "Waiting for you",

  // ---- Profile ----
  "profile.title": "Profile",
  "profile.phoneLabel": "Phone",
  "profile.nickLabel": "Nickname",
  "profile.nickSave": "Save",
  "profile.nickSaving": "Saving…",
  "profile.nickSaved": "Nickname updated ✓",
  "profile.langLabel": "Language",
  "profile.statusTitle": "My status",
  "profile.status.clanIn": "In clan “{name}”",
  "profile.status.clanNone": "No clan yet",
  "profile.status.prizeGranted": "Hero's Week prize activated",
  "profile.status.prizeEligible": "Prize ready — claim it in the HQ",
  "profile.status.prizeLocked": "Prize not unlocked yet",
  "profile.toHub": "To the HQ",
  "profile.logout": "Log out",

  // units
  "unit.meters": "m",
  "unit.watts": "W",
  "unit.percent": "%",

  // ---- Clan ----
  "clan.noPhone": "No phone number",
  "clan.back": "Back",
  "clan.createTitle": "Create a clan",
  "clan.joinTitle": "Join with a code",
  "clan.nameLabel": "Clan name",
  "clan.namePlaceholder": "e.g. Tigers",
  "clan.mottoLabel": "Motto (optional)",
  "clan.mottoPlaceholder": "All for one",
  "clan.emojiLabel": "Emoji (optional)",
  "clan.codeLabel": "Clan code",
  "clan.codePlaceholder": "For example, TIGR12",
  "clan.codeHint": "The clan leader will give you the code.",
  "clan.create": "Create a clan",
  "clan.creating": "Creating…",
  "clan.join": "Join",
  "clan.joining": "Joining…",
  "clan.errNoName": "Enter a clan name",
  "clan.errNameLatin": "Clan name — Latin letters, digits and spaces only (2–24 characters)",
  "clan.errNoCode": "Enter a clan code",
  "clan.errAlreadyIn": "You're already in a clan",
  "clan.errCreateFailed": "Couldn't create the clan",
  "clan.errJoinFailed": "Couldn't join the clan",
    "task.header": "Task",
  "task.logo_story.title": "Group photo: HJ",
  "task.logo_story.desc":
    "Take a group photo spelling the letters \"HJ\" with your bodies. Every clan member posts the photo to stories and tags @herosjourneykz and @oyu.fest.",
  "task.story.instaLabel": "Your Instagram",
  "task.story.instaPh": "@username",
  "task.story.checkbox": "I posted the story and tagged both accounts",
  "task.story.submit": "Send for review",
  "task.story.submitting": "Sending…",
  "task.story.pending": "⏳ Under review",
  "task.story.pendingHint": "A moderator will check the story and mark it complete.",
  "task.story.approved": "Completed 🎉",
  "task.story.progress": "Completed: {done} of {total}",
  "task.story.needClan": "This is a clan task — create or join a clan first.",
  "task.story.errNoInsta": "Enter your Instagram",
  "task.story.st.pending": "under review",
  "task.story.st.none": "not posted yet",
  "task.story.st.approved": "done",
  "task.group_plank.title": "Group plank",
  "task.group_plank.desc":
    "Find a Hero's Journey coach on site. On their signal, hold a «chair» plank as a team — linking hands, backs against each other — for 2 minutes. The coach keeps the time and marks the task complete.",
  "task.redbull_activity.title": "Red Bull activity",
  "task.redbull_activity.desc":
    "Complete any activity in our partner Red Bull's zone as a clan. A zone staff member marks completion. Sharing a story? Tag @redbullkazakhstan!",
  "clan.tasksTitle": "Clan tasks",
  "clan.tasksIntro": "Complete them as a team — everyone gets Hero's Week:",
  "clan.list.title": "Festival clans",
  "clan.list.empty": "No clans yet — create the first one!",
  "clan.list.yours": "Your clan",
  "clan.list.members": "Members: {count}",
  "clan.list.tasks": "Tasks: {done}/{total}",
  "clan.list.completed": "All tasks",

  // ---- Coach ----
  "coach.title": "Coach panel",
  "coach.title.coach": "Coach panel",
  "coach.title.marketing": "Marketing panel",
  "coach.title.redbull": "Red Bull panel",
  "coach.title.admin": "Staff panel",
  "coach.tab.clans": "Clans",
  "coach.myTaskProgress": "Your task is checked for {done} of {total} clans",
  "coach.rowing.recent": "Recently recorded",
  "coach.board.hint": "Top 5 of each standings. Final results — after competitions end on July 5.",
  "coach.rowing.nickLabel": "Participant nickname",
  "coach.rowing.nickPlaceholder": "hero_77",
  "coach.rowing.orPhoneLabel": "…or phone",
  "coach.rowing.errWho": "Enter the participant's nickname or phone",
  "coach.rowing.errNickUnsupported":
    "The server doesn't accept nickname entries yet — enter the participant's phone number",
  "coach.rowing.editHint": "Recording again for the same participant overwrites the result — that's how you fix mistakes. Tap a row in \"Recently recorded\" to prefill.",
  "error.participant_not_found": "Participant not found — check the nickname or phone",
  "coach.tab.rowing": "Rowing",
  "coach.prizeGranted": "prize granted",
  "coach.ready": "ready",
  "coach.leader": "Leader: {name}",
  "coach.members": "Members: {count} · Tasks: {done}/{total}",
  "coach.noTasks": "No tasks",
  "coach.searchPlaceholder": "Search by clan name or leader",
  "coach.nothingFound": "Nothing found",
  "coach.noClans": "No clans yet",
  "coach.errLoadClans": "Couldn't load clans",
  "coach.errCheck": "Couldn't mark the task",
  "coach.rowing.recordTitle": "Record a result",
  "coach.rowing.guestPhone": "Guest's phone",
  "coach.rowing.distanceLabel": "Distance, m",
  "coach.rowing.distancePlaceholder": "for example, 500",
  "coach.rowing.save": "Record result",
  "coach.rowing.saving": "Saving…",
  "coach.rowing.distance": "Distance",
  "coach.rowing.power": "Power",
  "coach.rowing.leaderboard": "Leaderboard",
  "coach.rowing.guestFallback": "Guest",
  "coach.rowing.boardEmpty": "No results yet",
  "coach.rowing.errPhone": "Check the phone number",
  "coach.rowing.errDistance": "Enter the distance in meters",
  "coach.rowing.errSave": "Couldn't record the result",
  "coach.rowing.errBoard": "Couldn't load the leaderboard",
  "lb.title": "Leaderboard · Find Your Power",
  "lb.live": "live",
  "lb.updated": "Updated",
  "lb.participants": "Athletes: {n}",
  "lb.total": "Together we rowed {km} km",
  "lb.offline": "no connection",
  "lb.women": "Women",
  "lb.men": "Men",
  "lb.spotlight.recorded": "Result recorded!",
  "lb.spotlight.placeWomen": "#{rank} among women",
  "lb.spotlight.placeMen": "#{rank} among men",
  "lb.spotlight.overall": "#{rank} overall",
  "staff.title": "Staff screen",
  "staff.subtitle": "Enter the access code. Ask the organizer for it.",
  "staff.placeholder": "Access code",
  "staff.submit": "Enter",
  "staff.checking": "Checking…",
  "staff.error": "Wrong code",
  "staff.youAre": "You: {role}",
  "admin.title": "Admin panel",
  "admin.tab.stats": "Statistics",
  "admin.tab.tasks": "Tasks",
  "admin.tab.winners": "Winners",
  "admin.tab.stories": "Stories",
  "admin.story.title": "Story review",
  "admin.story.empty": "No submissions yet",
  "admin.story.pendingCount": "pending: {n}",
  "admin.story.approve": "Approve",
  "admin.story.reject": "Reject",
  "admin.story.pending": "pending",
  "admin.story.approved": "approved",
  "admin.winners.women": "Top-3 — women",
  "admin.winners.men": "Top-3 — men",
  "admin.winners.empty": "No results yet",
  "admin.winners.hint": "Final rowing leaderboard. Contact the winners to hand out the reward.",
  "admin.forbidden": "Organizer access only.",
  "admin.refresh": "Refresh",
  "admin.stat.participants": "Registrations",
  "admin.stat.menWomen": "M {men} · F {women} · n/a {other}",
  "admin.stat.clans": "Clans",
  "admin.stat.clansSub": "ready {ready} · completed {completed}",
  "admin.stat.members": "Clan members",
  "admin.stat.rowing": "Rowing",
  "admin.stat.rowingSub": "results · with prize {prize}",
  "admin.stat.top": "Top: {name} · {power} W",
  "admin.stat.prizes": "Hero's Week granted",
  "admin.stat.tasksTitle": "Task completion",
  "admin.stat.clansDone": "{n} clans",
  "admin.empty": "—",
  "admin.tab.rowing": "Rowing",
  "admin.rowing.hint": "All rowing results: {n}",
  "admin.rowing.empty": "No results yet.",
  "admin.rowing.page": "Page {p} of {n}",
  "admin.rowing.noPhones": "Phone numbers will appear once the backend serves /admin/rowing.",
  "admin.rowing.f": "F",
  "admin.rowing.m": "M",
  "admin.inbody.title": "Completed InBody",
  "admin.inbody.empty": "No one has taken the scan yet.",
  "admin.inbody.unavailable": "The list will appear once the backend serves /admin/inbody.",
  "admin.task.listTitle": "All tasks",
  "admin.task.newTitle": "New task",
  "admin.task.titleLabel": "Task title",
  "admin.task.titlePh": "What the clan must do",
  "admin.task.roleLabel": "Confirmed by",
  "admin.task.active": "Active",
  "admin.task.sort": "Order",
  "admin.task.create": "Create task",
  "admin.task.save": "Save",
  "admin.task.saving": "Saving…",
  "admin.task.off": "off",
  "admin.task.errSave": "Couldn't save",
  "admin.task.errLoad": "Couldn't load",
  "staff.role.admin": "Organizer",
  "staff.role.marketing": "Marketing",
  "staff.role.coach": "Coach",
  "staff.role.redbull": "RedBull",

  // ---- InBody ----
  "inbody.back": "Back",
  "inbody.title": "Digitize your body",
  "inbody.loading": "Loading…",
  "inbody.empty": "Take an InBody test at the station (Zone 2) — the result will show up here.",
  "inbody.appPrompt": "Download the Hero's Journey app and sign in with your phone number — your full measurement results (weight, muscle, fat, metabolism) will appear there.",
  "inbody.score": "InBody score",
  "inbody.measuredAt": "Measured: {date}",
  "inbody.about.title": "What is InBody",
  "inbody.about.body":
    "InBody is a body composition analyzer. You step on the platform, hold the handles — and in 60 seconds it shows what you are made of. Not just total weight, but the breakdown: how much muscle, how much fat, where exactly that fat sits and how much water is in your tissues. The device passes a weak, safe current through your body — muscle, fat and water conduct it differently, and the whole picture is built on that difference. The method is called bioimpedance and is used by clinics and sports teams worldwide.",
  "inbody.metabolicAge": "Metabolic age",
  "inbody.pbf": "Body fat %",
  "inbody.ctaQuestion":
    "Want to see the full breakdown — weight, muscle, visceral fat and metabolism?",
  "inbody.ctaHint": "Open the full report in the Hero's Journey app",
  "inbody.download": "Download the app",

  // ---- Done ----
  "done.title": "All tasks complete!",
  "done.subtitle": "Your clan claimed the prize — 3 workouts in the Hero's Week program.",
  "done.appHintWithPhone":
    "Download the Hero's Journey app and log in with {phone} — your gift is already inside.",
  "done.appHintNoPhone":
    "Download the Hero's Journey app and log in with your phone number — your gift is already inside.",
  "done.appStore": "Download on the App Store",
  "done.googlePlay": "Get it on Google Play",
  "done.linksSoon": "App links coming soon.",

  // ---- PrizeModal ----
  "prize.today": "Today",
  "prize.tomorrow": "Tomorrow",
  "prize.dayAfter": "Day after tomorrow",
  "prize.success.title": "Hero's Week activated",
  "prize.success.body":
    "We've linked your gift to the chosen gym and date. Download the app and log in with your number — your prize is already inside.",
  "prize.success.done": "Done",
  "prize.title": "Claim Hero's Week",
  "prize.close": "Close",
  "prize.intro": "Choose a gym and the day you want to start training.",
  "prize.clubLabel": "Gym",
  "prize.loadingClubs": "Loading gyms…",
  "prize.clubsEmpty": "The gym list is empty",
  "prize.cityOther": "Other cities",
  "prize.startDateLabel": "Start date",
  "prize.submit": "Activate prize",
  "prize.submitting": "Activating…",
  "prize.errNoClub": "Choose a gym",
  "prize.errNoDate": "Choose a start date",
  "prize.errLoadClubs": "Couldn't load the gym list",
  "prize.errGrantFailed": "Couldn't activate the prize, try again",
  "prize.errGrant": "Couldn't activate the prize",
  "prize.gift.title": "Claim your gift Hero's Week",
  "prize.gift.intro": "You're already our client — so you get a gift Hero's Week.",
  "prize.gift.note":
    "This is a gift certificate: it'll appear in your Hero's Journey account. Activate it within 3 months — you'll pick the gym and start date at activation.",
  "prize.gift.claim": "Claim gift",
  "prize.gift.success.title": "It's yours 🎁",
  "prize.gift.success.body":
    "A gift Hero's Week has been added to your Hero's Journey account. Activate it within 3 months.",

  // ---- MemberList ----
  "members.title": "Members",
  "members.fallbackName": "Member",
  "members.unknownInitial": "?",
  "members.leader": "Leader",
  "members.empty": "No one in the clan yet",

  // ---- MemberSlots ----
  "slots.member": "Member {n}",
  "slots.remove": "Remove",
  "slots.add": "+ Add member",

  // ---- TaskList ----
  "tasks.title": "Tasks",
  "tasks.progress": "{done} of {total}",
  "tasks.empty": "No tasks yet",

  // ---- ScoreRing ----
  "score.outOf": "of {max}",

  // ---- Faq ----
  "faq.title": "Questions and answers",
  "faq.q1": "How do I get the workouts?",
  "faq.a1": "Log into the app with this same phone number — your gift is already inside.",

  // ---- Backend error codes ----
  "error.generic": "Something went wrong, try again",
  "error.existing_client":
    "This number is already in our database — the prize is only for new guests.",
  "error.nick_taken": "That nickname is taken — pick another",
  "error.already_in_clan": "You're already in a clan",
  "error.clan_not_found": "No clan found with that code — check the code",
  "error.not_eligible":
    "To claim the prize, first complete clan tasks or do the rowing station.",
  "error.bad_start_date": "Choose a valid start date.",
  "error.no_hw_event_for_date": "No sessions on that date — pick another day.",
  "error.rate_limited": "Too many attempts. Wait a minute and try again.",
  "error.forbidden_for_role": "This task is confirmed by a different person.",
  "error.not_registered":
    "This guest hasn't registered for the festival yet.",
};

export const dict: Record<Lang, Dict> = { kk, ru, en };
